'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    LanguagePicker: {
        header: 'Choose a language'
    },
    Menu: {
        elem1: {
            title: 'Cases',
            items: {
                item1: {
                    title: 'Case 1',
                    subtitle: 'Who bombarded Omran’s home?',
                    image: '/media/image/menu1.png',
                    url: '/who-bombed-omran-home/'
                },
                item2: {
                    title: 'Case 2',
                    subtitle: 'Who knocked down the MH17?',
                    image: '/media/image/menu2.png',
                    url: '/who-downed-mh17/'
                },
                item3: {
                    title: 'Case 3',
                    subtitle: 'Who attacked the humanitarian convoy at Urm Al Kubra?',
                    image: '/media/image/menu3.jpg',
                    url: '/who-destroyed-the-humanitarian-convoy/'
                }
            }
        },
        elem2: {
            title: 'Homepage',
            url: '/'
        },
        elem3: {
            title: 'Tutorials',
            url: '/tutorials/'
        },
        elem4: {
            title: 'Watch the Documentary',
            url: '/documentary/'
        }
    },
    Home: {
        hint: 'Puedes invitar a otros a esta sesión compartiendo la URL',
        h2: 'Each day, thousands of people place testimonies on the social networks of the injustices that they witness.',
        h2sub: 'Their comments, images or videos can be used to verify the information that we commonly come across.',
        h3: 'Discover the truth',
        h4: 'This webdoc, in which you will have to overcome interactive challenges, recreate the investigations of this network of citizens that intends to dismantle war lies using those informative resources within everyone’s reach.',
        infoTitle: 'Información',
        infoDesc: 'Explicación de cómo funciona',
        titleCase1: 'Discover the truth',
        linkCase1: 'who-bombed-omran-home/',
        buttonContinue: 'Skip intro',
        footer: {
            elem1: {
                name: 'EN PORTADA',
                link: 'http://www.rtve.es/television/en-portada/guerra-mentira/',
                icon: 'icon-enportada'
            },
            elem2: {
                name: 'Lab RTVE',
                link: 'http://lab.rtve.es/',
                icon: 'icon-logolab'
            },
            elem3: {
                name: 'CREDITS',
                link: 'credits/',
                icon: 'icon-enportada'
            }
        },
        instructions: [{
            txt: 'These images may prove to be upsetting, just like so many others that you may see daily on a news programme',
            icon: 'icon-warning'
        }, {
            txt: 'This webdoc has conversational navigation, of which you will form part',
            icon: 'icon-talk'
        }, {
            txt: 'Stay alert, you will have to solve an interactive challenge at the end of the conversations',
            icon: 'icon-hand'
        }],
        parallaxContent: [{
            type: 'string',
            velocity: '0.10',
            txt: 'War'
        }, {
            type: 'image',
            velocity: '0.5',
            img: 'lineHome.png'
        }, {
            type: 'string',
            velocity: '0.20',
            txt: 'against'
        }, {
            type: 'image',
            velocity: '0.30',
            img: 'lineHome.png'
        }, {
            type: 'string',
            velocity: '0.4',
            txt: 'lies'
        }]
    },
    Mobile: {
        start: 'Start',
        connecting: 'Connecting',
        connected: 'Connected',
        endText: 'Fin de conversación',
        logo: '/media/image/logoEn.png',
        messages: [[{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Are you there?',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Scroll down to chat',
                author: '',
                skipMessageBlocks: 0
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'We need your help',
            author: 'Duncan',
            inbound: true,
            duration: 700
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Answer',
                author: 'You',
                skipMessageBlocks: 0,
                messageToShow: 'Is this for me? What do you want me to do?'
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Look at this video and you’ll understand',
            author: 'Duncan',
            inbound: true,
            duration: 1000,
            showMedia: {
                elements: [{
                    type: 'video',
                    src: 'media/video/introHomeMobile.mp4',
                    subtitle: 'Alastair Reid'
                }],
                srcThumbnail: 'media/image/omranth1.jpg',
                mediaId: 1
            },
            messageId: 1
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'We are attempting to discover the truth regarding many of the war crimes committed daily in the world',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Can we count on you?',
            author: 'Duncan',
            inbound: true,
            duration: 1000
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'Yes... How do you go about it?',
                author: 'You',
                skipMessageBlocks: 0
            }, {
                message: 'What can I do?',
                author: 'You',
                skipMessageBlocks: 3
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'It is simple. We use information that can be accessed by everyone. It is known as verification of open sources',
            author: 'Duncan',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Images, testimonies, videos of witnesses on the ground',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'We compile all the data we can and verify it',
            author: 'Duncan',
            inbound: true,
            duration: 700
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'You can, for example, help us to verify if the images are real',
            author: 'Carvin',
            inbound: true,
            duration: 1000,
            showMedia: {
                elements: [{
                    type: 'image',
                    src: 'media/image/Night-vs-day.jpg'
                }],
                srcThumbnail: 'media/image/Night-vs-dayth.jpg',
                mediaId: 2
            },
            messageId: 2
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'You can also geo-locate them, to know which place in the world they correspond to',
            author: 'Carvin',
            inbound: true,
            duration: 1000,
            showMedia: {
                elements: [{
                    type: 'image',
                    src: 'media/image/Attack-5.jpg'
                }],
                srcThumbnail: 'media/image/Attack-5th.jpg',
                mediaId: 3
            },
            messageId: 3
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Or search on Twitter, Facebook, Youtube or any other social network for witnesses to help us to verify what has happened',
            author: 'Duncan',
            inbound: true,
            duration: 1000
        }, {
            type: 'choice',
            duration: 1000,
            inbound: true,
            choices: [{
                message: 'I don’t know how to do that',
                author: 'You',
                skipMessageBlocks: 0
            }, {
                message: "Ok, let's begin",
                author: 'You',
                skipMessageBlocks: 2
            }]
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Normal. It has only been applied for a few years but you don’t need to be an expert to begin',
            author: 'Carvin',
            inbound: true,
            duration: 1000
        }], [{
            type: 'typing',
            duration: 1000,
            inbound: true
        }, {
            message: 'Watch this video',
            author: 'Duncan',
            inbound: true,
            duration: 2500,
            showMedia: {
                elements: [{
                    type: 'video',
                    src: 'media/video/finalCaseMobile.mp4',
                    subtitle: 'Alastair Reid'
                }],
                srcThumbnail: 'media/image/trailerth.jpg',
                hoverTitle: 'Promo de En Portada',
                hoverText: 'Documentary trailer',
                mediaId: 4
            },
            messageId: 4
        }], [{
            message: 'To begin investigating, access this webdoc from a computer or tablet',
            author: 'Carvin',
            inbound: true,
            duration: 2700
        }]],
        trailer: {
            src: 'media/video/trailerMobile.mp4',
            srcSubtitles: 'media/subtitles/trailerMobile.vtt',
            text: 'Mira el trailer'
        }
    },
    About: {
        title: 'The project',
        menu: {
            elem1: {
                name: 'SOURCES'
            },
            elem2: {
                name: 'DICTIONARY'
            },
            elem3: {
                name: 'TUTORIALS'
            }
        },
        dictionary: {
            elems: [{
                letter: 'b',
                words: [{
                    word: 'Bellingcat',
                    desc: 'This website was founded by Eliot Higgins after two years’ investigation on his own, and provides a platform for a group of volunteers to perform exhaustive studies.'
                }, {
                    word: 'Barrel bombs',
                    desc: 'They are a type of home-made or improvised explosive device, IED, which consists of barrels full of explosives, frequently chemical weapons, and metallic fragments such as nails, which are projected as shrapnel. They are normally launched from helicopters and their scant accuracy has made them the most used type of weapon against civilian areas.'
                }, {
                    word: 'BUK',
                    desc: 'The Buk missile system (in Russian "Бук") is an anti-air defence system, armed with land-to-air missiles, developed by the Soviet Union and subsequently by Russia. A dozen countries have a BUK in their arsenal. They are capable of intercepting cruise missiles, smart bombs, aircraft and drones.'
                }]
            }, {
                letter: 'c',
                words: [{
                    word: 'Ceasefire:',
                    desc: 'The temporary cessation of a war, or any armed conflict, in which the warring parties agree mutually or unilaterally to cease fighting. It may occur with respect to the whole battle or partially in any area affected by it.'
                }, {
                    word: 'Citizen Evidence Lab',
                    desc: 'Created by Amnesty International, this organisation aims to support investigators and defenders of Human Rights, thereby more easily taking advantage of the new digital data flows from conflict zones and other critical points of the planet. By the way, they are looking for employees.'
                }]
            }, {
                letter: 'e',
                words: [{
                    word: 'Euromaidan',
                    desc: 'The name given to the demonstrations and disturbances of a European and nationalist nature in the Ukraine, which led to the removal of the elected chairman Víktor Yanukóvich on the night of 21 November 2013. It was the cause of the clashes between pro-Russians and pro-Europeans still involved in an armed conflict for the country.'
                }]
            }, {
                letter: 'f',
                words: [{
                    word: 'First Draft',
                    desc: 'First Draft engages in improving skills and standards in the production and exchange of on-line information. It mainly focuses on enabling journalists to adopt new open source verification techniques.'
                }, {
                    word: 'Forensic Architecture',
                    desc: 'The Research Agency of the University of London that performs forensic architecture projects. Its work for all types of pro-Human Rights international organisations endeavours to virtually reconstruct places in which such rights were violated.'
                }]
            }, {
                letter: 'h',
                words: [{
                    word: 'Humanitarian corridors',
                    desc: 'Their objective is to facilitate the distribution of humanitarian aid among civilians during an armed conflict and the passage of the civilian population through areas of different sides. The different sides must undertake to respect the specified areas and not carry out attacks therein.'
                }, {
                    word: 'Hydrochloric gas attack',
                    desc: 'A weapon that was used in the First World War and which, sadly, has re-appeared in Syria since 2014.  Frequently used against the civilian population. Highly corrosive and irritating, a brief low-level exposure causes irritation in the throat, and large doses cause death.'
                }]
            }, {
                letter: 'w',
                words: [{
                    word: 'White Helmets',
                    desc: 'Thereby named since their work is similar to that of the White Helmets Commission created in Argentina in 1993, it is a Syrian civilian body engaging in humanitarian aid. DCS y Difaa al Medani Suri in Arabic, brings together nearly 3,000 people at more than 100 centres throughout the country with the sole intention of saving lives. They were candidates for the 2016 Nobel peace prize, despite the fact that the Government and Russia accuses them of being a terrorist group.'
                }]
            }]
        },
        investigations: {
            elems: [{
                title: 'The Guta carnage',
                desc: 'More than 1,400 people were killed and 3,000 were injured in an attack performed with chemical weapons, on 21 August 2013, in the Guta neighbourhood, to the south of Damasco. Revealing who was responsible for this crime against humanity has, to date, been one of the most important works of Eliot Higgins.',
                subtitle: 'Access the investigation at',
                links: [{
                    name: 'Bellingcat',
                    link: 'https://www.bellingcat.com/news/mena/2015/08/20/8_21chemicaltrail/'
                }, {
                    name: 'Human Rights Watch',
                    link: 'https://www.hrw.org/sites/default/files/reports/syria_cw0913_web_1.pdf'
                }]
            }, {
                title: 'War crimes in Maiduguri (Nigeria)',
                desc: 'The conflict between the Nigerian army and the terrorist group Boko Haram to gain control of the city of Maiduguri led to the killing in cold blood of hundreds of innocent people. Specifically, 640 escaped prisoners, who were captured unarmed, were extra-officially executed by the army. Amnesty International worked with anonymous videos recorded in the place of the events in order to show the facts.',
                subtitle: 'Read how it was possible to demonstrate it',
                links: [{
                    name: 'International Amnesty',
                    link: 'https://www.es.amnesty.org/en-que-estamos/blog/historia/articulo/como-nos-ayudo-la-tecnologia-a-denunciar-los-crimenes-de-guerra-de-nigeria/'
                }]
            }, {
                title: 'Yemen, a forgotten population at war',
                desc: 'Despite the similarities with what is going on in Syria, the war in Yemen does not take up so much time in the news. The conflict began in this, the poorest Arab country, in 2014. Various national and international factions are involved, which clash with the civilian population in a situation of extreme need.',
                subtitle: 'See the verifications',
                links: [{
                    name: 'Bellingcat',
                    link: 'https://www.bellingcat.com/?s=yemen'
                }]
            }, {
                title: 'Saydnaya, inside the Syrian torture jail',
                desc: 'Saydnaya prison in Syria is hell on earth. Survivors tell stories of torture, inhumane conditions and death.  Forensic Architecture, in collaboration with Amnesty International, carried out a virtual re-creation of the prison, based on the testimonies of 65 survivors.',
                subtitle: 'See the recreation',
                links: [{
                    name: 'Forensic Architecture',
                    link: 'http://www.forensic-architecture.org/case/saydnaya/'
                }]
            }, {
                title: 'Rafah: Black Friday',
                desc: 'On 01 August 2014, during a ceasefire, Israel indiscriminately bombarded Rafah, a town to the south of the Gaza Strip. A cell of the armed wing of Hamas had laid an ambush for Israeli soldiers seeking to neutralise a tunnel connected to Israeli territory. In the Palestine attack, two soldiers died, while their leader, Lieutenant Hadar Goldin disappeared without knowing whether he was dead or alive. Amnesty International and Forensic Architecture drafted a report in which they accused Israel of war crimes.',
                subtitle: 'See full report',
                links: [{
                    name: 'International Amnesty',
                    link: 'https://blackfriday.amnesty.org/'
                }]
            }]
        },
        tutorials: {
            elems: [{
                title: 'How to verify images',
                desc: 'Reference guide to help your work with images',
                subtitle: '',
                links: [{
                    name: 'Observation Challenge',
                    link: 'https://firstdraftnews.com/articulate/obsc/story.html'
                }, {
                    name: 'Google Earth verification',
                    link: 'https://firstdraftnews.com/resource/how-to-verify-images-like-a-pro-with-google-earth/'
                }]
            }, {
                title: 'Geolocation',
                desc: 'Geolocation is a vital step in the process of verifying.',
                subtitle: '',
                links: [{
                    name: 'First Draft Challenge',
                    link: 'https://firstdraftnews.com/articulate/glch/story.html'
                }, {
                    name: 'Geoguessr',
                    link: 'https://geoguessr.com/'
                }]
            }, {
                title: 'Video',
                desc: 'It is possible to extract hidden information from YouTube video.',
                subtitle: '',
                links: [{
                    name: 'Citizen Evidence Lab',
                    link: 'http://fluidsurveys.com/surveys/ckoettl/citizen-video-assessment-exercise/'
                }]
            }, {
                title: 'How to find witnesses in social networks?',
                desc: 'The search for news on social networks is an increasingly common practice.',
                subtitle: '',
                links: [{
                    name: 'Facebook',
                    link: 'https://firstdraftnews.com/resource/2845/'
                }, {
                    name: 'Facebook Live',
                    link: 'https://firstdraftnews.com/resource/find-facebook-live-videos-news/'
                }, {
                    name: 'Instagram',
                    link: 'https://firstdraftnews.com/resource/find-newsworthy-pictures-videos-instagram/'
                }, {
                    name: 'Twitter',
                    link: 'https://firstdraftnews.com/resource/how-to-find-tweets-by-location/'
                }]
            }]
        }
    },
    Credits: {
        block1: {
            title: 'LAB RTVE.ES CREDITS',
            elements: {
                elem1: {
                    job: 'Script',
                    personName: 'César Peña'
                },
                elem2: {
                    job: 'TV Direction',
                    personName: 'Marcos Martín'
                },
                elem3: {
                    job: 'Development',
                    personName: 'Lab RTVE.es'
                },
                elem4: {
                    job: 'Design',
                    personName: 'Lab RTVE.es'
                },
                elem5: {
                    job: 'Voice',
                    personName: 'Paula Aller'
                },
                elem6: {
                    job: 'Coordination',
                    personName: 'Miriam Hernanz'
                }
            }
        },
        block2: {
            title: 'TVE CREDITS',
            elements: {
                elem1: {
                    job: 'Script',
                    personName: 'Yolanda Álvarez'
                },
                elem2: {
                    job: 'TV Direction',
                    personName: 'Marcos Martín'
                },
                elem3: {
                    job: 'Camera and Sounds',
                    personName: 'José Martínez, Alfredo Sánchez-Toledo'
                },
                elem5: {
                    job: 'Edition',
                    personName: 'Marga Serrano'
                },
                elem6: {
                    job: 'Director',
                    personName: 'José Antonio Guardiola'
                }
            }
        },
        block3: {
            title: 'Special Thanks',
            elem1: {
                name: 'Con Ucrania',
                link: 'https://conucrania.com/'
            }
        },
        footer: {
            title: 'A transmedia project',
            elem1: {
                name: 'En Portada',
                link: 'http://www.rtve.es/television/en-portada/',
                icon: 'icon-enportada'
            },
            elem2: {
                name: 'Lab RTVE',
                link: 'http://lab.rtve.es',
                icon: 'icon-logolab'
            }
        },
        name: 'Credits'
    },
    Case: {
        'case1': {
            title: 'Who bombarded Omran’s home?',
            titleBottom: 'Look for signs that the truck has been attacked by an aerial missile',
            explanationInteraction: '',
            nameMenu: 'CASE 1',
            imageMenu: '/media/image/menu1.png',
            url: '/who-bombed-omran-home/',
            description: 'Discover who is responsible for the bombardments of the civilian population such as Omran using investigation methods performed by and for citizens, conducted by Bellingcat.',
            button: 'Discover the truth',
            buttonStart: 'Start',
            buttonSkip: 'Skip intro',
            buttonContinue: 'Continue',
            buttonGoInteractive: 'Interactive',
            background: 'media/image/bg-case1.jpg',
            logoFooter: 'media/image/logoEn.png',
            wordsParallax: ['media/image/word-about.png', 'media/image/word-forget.png', 'media/image/word-here.png', 'media/image/word-playing.png', 'media/image/word-to-win.png'],
            messages: [[{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Ey! Have you seen these images?',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/7cfBmRW3isc?autoplay=1&enablejsapi=1',
                        subtitle: 'Vídeo del rescate'
                    }],
                    srcThumbnail: 'media/image/omranth1.jpg',
                    hoverTitle: 'Omran’s rescue goes viral',
                    hoverText: 'The Youtube images of the rescue of a five-year-old child from among the rubble of his/her bombarded home make the world shudder, as explanations on the atrocity are demanded.',
                    mediaId: 1
                },
                messageId: 1
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Scroll down to chat',
                    author: '',
                    skipMessageBlocks: 0
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'They are being shown around the world. Poor child, what a look. His name is Omran...',
                author: 'Duncan',
                inbound: true,
                duration: 700
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Do you know where it was?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The title of the video on Youtube in Arabic is "<a href="https://www.youtube.com/watch?v=7cfBmRW3isc" target="_blank">المشاهد الأولية لقصف طائرات حربية يعتقد أنها روسية على حي القاطرجي</a>"',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I don’t understand Arabic...',
                author: 'Carvin',
                inbound: true,
                duration: 700
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It is not necessary. This is the recommendation of experts such as Alastair Reid, of <a href="https://firstdraftnews.com/" target="_blank">First Draft News</a>, in this case',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/reid1.mp4',
                        srcSubtitles: 'media/subtitles/caso1-reid1.vtt',
                        subtitle: 'Alastair Reid',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/reid1th.jpg',
                    hoverTitle: 'How to investigate in other languages',
                    hoverText: 'Alastair Reid, First Draft News editor, explains the keys.',
                    mediaId: 2
                },
                messageId: 2
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Put it into Google Translate',
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continue without translating',
                    author: 'You',
                    skipMessageBlocks: 5
                }]
            }], [{
                message: 'It is translated as “Initial scenes of bombardments of combat planes thought to be Russian in the Alqatrgi neighbourhood”',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 700,
                inbound: true
            }, {
                message: 'And where is that?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It is a rebel neighbourhood of Alepo',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I haven’t heard of it either. Do you think it comes from a reliable source?',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Let me see… the video was posted by AMC "<a href="http://www.amc-sy.net/" target="_blank">Aleppo Media Center</a>" which is a local body. Furthermore, this other video has been posted by Orient News on the child’s rescue: <a href="https://www.youtube.com/watch?v=QIP-jokI3gM" target="_blank">https://www.youtube.com/watch?v=QIP-jokI3gM</a>',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'So you think it has been the Russians then? How can we verify it?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'There are people such as Reid that already make it their task. This is his advice',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/reid2.mp4',
                        srcSubtitles: 'media/subtitles/caso1-reid2.vtt',
                        subtitle: 'Alastair Reid',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/reid2th.jpg',
                    hoverTitle: 'Principles of verification?',
                    hoverText: 'Try to answer 5 w’s.',
                    mediaId: 3
                },
                messageId: 3
            }], [{
                message: 'I have found <a href="https://www.facebook.com/permalink.php?story_fbid=1786927808216634&id=1492252324350852" target="_blank">this press release on the official Facebook page</a> of the Russian army',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.facebook.com/plugins/post.php?href=https%3A%2F%2Fwww.facebook.com%2Fpermalink.php%3Fstory_fbid%3D1786927808216634%26id%3D1492252324350852&width=500',
                        subtitle: 'Official statement',
                        style: { 'min-height': '15vw' }
                    }],
                    srcThumbnail: 'media/image/comunicadoomranth.jpg',
                    hoverTitle: 'Humanitarian corridors',
                    hoverText: 'Russia asserts that its aeroplanes do not bombard areas close to humanitarian corridors, and that Omran’s house was between two corridors.',
                    mediaId: 4
                },
                messageId: 4
            }], [{
                type: 'typing',
                duration: 700,
                inbound: true
            }, {
                message: 'It seems that the Russians claim that it has not been them, because the bombardment site is between two of the six humanitarian corridors',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'They were provided so that civilians in the rebel area could abandon the zone pacifically, and they assert that they did not bombard these corridors',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 700,
                inbound: true
            }, {
                message: 'And do they normally respect them or are they a trap?',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'See proof ',
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: 'Let’s continue investigating',
                    author: 'You',
                    skipMessageBlocks: 6
                }]
            }], [{
                message: 'According to the Russian media, people are abandoning the rebel area without problems',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/pantallazort.jpg',
                        subtitle: 'The Russian media use images of Alepo to certify the functioning of the corridors. However, the civilians deny this information'
                    }],
                    srcThumbnail: 'media/image/pantallazortth.jpg',
                    hoverTitle: 'An uncomfortable witness',
                    hoverText: 'The Russian media use images of Alepo to certify the functioning of the corridors. However, the civilians deny this information',
                    mediaId: 5
                },
                messageId: 5
            }], [{
                type: 'typing',
                duration: 700,
                inbound: true
            }, {
                message: 'Do not be so sure',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'A video from the Qasioun News Agency is circulating on Youtube in which the same man appearing with his daughter in his arms in the background in the RT video states that he was queuing to buy bread and not abandoning the rebel area',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I’m telling you, the <a href="https://www.bellingcat.com/news/mena/2016/09/01/fact-checking-russias-claim-didnt-bomb-5-year-old-syria/" target="_blank">Bellingcat</a> website has already verified it',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/-_D1NEvZZNg?autoplay=1&enablejsapi=1',
                        subtitle: 'Testimonio'
                    }],
                    srcThumbnail: 'media/image/testimonioth.jpg',
                    hoverTitle: 'Witnesses speak',
                    hoverText: 'One of the citizens who according to the RT were using the humanitarian corridor explains that the images were taken out of context',
                    mediaId: 6
                },
                messageId: 6
            }], [{
                type: 'typing',
                duration: 700,
                inbound: true
            }, {
                message: 'It also states that he does not intend to abandon the rebel area',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Ok. We will rule out this line of investigation',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'What more do we know?',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Let us focus on whether or not there were humanitarian corridors',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The spokesperson of the Russian army gave <a href="http://syria.mil.ru/en/index/syria/news/more.htm?id=12091371@egNews" target="_blank">a press conference</a> months before detailing their location',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/corredoresrusos.jpg',
                        subtitle: 'Sergei Rudskoy, Chief of Operations of the Russian General Staff, outlines the location of the humanitarian corridors to the media'
                    }],
                    srcThumbnail: 'media/image/corredoresrusosth.jpg',
                    hoverTitle: 'How many humanitarian corridors are there in Alepo?',
                    hoverText: 'Sergei Rudskoy, Chief of Operations of the Russian General Staff, outlines the location of the humanitarian corridors to the media',
                    mediaId: 7
                },
                messageId: 7
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'We could probably verify whether the bombardment was close to one of them',
                author: 'Duncan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'A Look this is the map distributed on the ground, in Alepo, on the corridors',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It has been posted by <a href="https://www.facebook.com/syrian.reporters/photos/a.575752362470341.1073741825.254488777930036/1125715137474058/?type=3&theater" target="_blank">Syrian Reporters</a> on their Facebook. The number of corridors does not coincide (on this one there are two less than on the Russian map), nor does their location',
                author: 'Carvin',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/corredoressirios.jpg',
                        subtitle: 'Sirian Reporters muestra en Facebook la información sobre los corredores humanitarios'
                    }],
                    srcThumbnail: 'media/image/corredoressiriosth.jpg',
                    hoverTitle: 'Information on land',
                    hoverText: 'Russia states that there are six in the city. However, the information distributed on land and shared in Facebook does not coincide in number or location.',
                    mediaId: 8
                },
                messageId: 8
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Put it into Google Maps',
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continue investigating',
                    author: 'You',
                    skipMessageBlocks: 2
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'This is what it would look like if we pass it on to a map…',
                author: 'Duncan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.google.com/maps/d/u/1/embed?mid=1w0xByR5uMjOcL8FTpQpliJ1HIkI',
                        subtitle: 'Superposición de mapas de los corredores humanitarios en Alepo.'
                    }],
                    srcThumbnail: 'media/image/Aleppo-corridorsth.jpg',
                    hoverTitle: 'Compare the maps',
                    hoverText: "Let us check how the actual location of the corridors are on a map, with respect to Omran's house.",
                    mediaId: 9
                },
                messageId: 9
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It’s true - it does not coincide with the official Russian map...',
                author: 'Silverman',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'So where was Omran’s house then?',
                author: 'Carvin',
                inbound: true,
                duration: 1000
            }]],
            parallaxContent: [{
                type: 'image',
                velocity: '0.65',
                img: 'lineCase1.png'
            }, {
                type: 'string',
                velocity: '0.5',
                txt: 'Case'
            }, {
                type: 'string',
                velocity: '0.20',
                txt: 'Omran'
            }, {
                type: 'image',
                velocity: '0.30',
                img: 'lineCase1.png'
            }, {
                type: 'string',
                velocity: '0.4',
                txt: '<h1>Who bombarded Omran’s home?</h1>'
            }, {
                type: 'image',
                velocity: '0.3',
                img: 'rectangleCase1.png'
            }],
            interaction: {
                instructions1: {
                    title: 'Pass the mouse over the two images in order to learn how to verify images'
                },
                explanation: {
                    view1: {
                        day: "Observe the form of the trunk and compare the two images in order to check whether they coincide",
                        night: "The shape and layout of the different elements can be a good reference to check the location on the map of an image."
                    },
                    view2: {
                        day: "The distance from other components coinciding with the tree can help in the verification",
                        night: "Other components such as the shapes of the windows or commercial premises in the buildings can serve as relevant clues"
                    },
                    view3: {
                        day: "The position of the canopy, the window and the tree show that both images belong to the site of the bombardment",
                        night: "The conditions of the light and the place from where the image was taken may hinder the verification"
                    }
                },
                instructions2: {
                    title: 'Compare images with satellite photography',
                    subtitle: 'Use the frames extracted from videos of the site of the attack in order to locate the position in the map'
                },
                photos: {
                    title: 'Select the clue and look for it clicking over the map',
                    correctTitle: 'Correct Location',
                    wrongTitle: "Keep on searching",
                    selectClue: 'Select one of the three clues on the right',
                    closeClue: 'Close the image to start',
                    pista: 'Clues:',
                    src: '/media/image/interactionCase1.jpg',
                    photo1: {
                        photoSrc: '/media/image/intCase1-photo1.jpg',
                        thumbSrc: '/media/image/intCase1-thumb1.png',
                        correctText: "The shape of the building and its position regarding those of its surroundings certify that this is the place we are looking for",
                        wrongText: "Try to locate a building higher than those in your environment. Use objects or referents that surround you to find the location."
                    },
                    photo2: {
                        photoSrc: '/media/image/intCase1-photo2.jpg',
                        thumbSrc: '/media/image/intCase1-thumb2.png',
                        correctText: "Despite the limited perspective of the satellite image, you have located the two buildings",
                        wrongText: "Locate the two parallel buildings which can be seen in the background of the image. Use the corner with the tree or the wall as a reference point. "
                    },
                    photo3: {
                        photoSrc: '/media/image/intCase1-photo3.jpg',
                        thumbSrc: '/media/image/intCase1-thumb3.png',
                        correctText: "The location of the three points certifies that the place in which Omran was rescued is the rebel district of Alqatrgi",
                        wrongText: "Look for a pile of stones or waste ground in the satellite image"
                    }
                }
            },
            conclusion: {
                title: 'Conclusions',
                text: ['Although it is not possible to demonstrate who carried out the bombardment, it is possible to state that it took the form of an air attack over the rebel area, as proven by the investigation conducted by Bellingcat', 'The arguments of the Russian Defence Ministry with respect to the humanitarian corridors do not coincide with the information provided on the ground, nor are the supposed witnesses used by the Russian media actually witnesses.', 'The suspicions on a rebel attack in its own area can be ruled out, since it does not have the necessary weapons to cause that type of destruction.', 'An attack with the characteristics of that suffered by Omran can only have been carried out using weapons of the Syrian government or of Russia.', 'All the conversations on this experience are a recreation of the exhaustive investigation carried out by Bellingcat.'],
                verification: {
                    text: 'Bellingcat investigation',
                    link: 'https://www.bellingcat.com/news/mena/2016/09/01/fact-checking-russias-claim-didnt-bomb-5-year-old-syria/'
                },
                nextStep: {
                    text: 'Next case',
                    link: '/who-downed-mh17/'
                },
                icon: 'icon-bomb'
            },
            icon: 'icon-plane',
            urlVideo: '/media/video/introCase1.mp4',
            urlSubtitles: '/media/subtitles/caso1-intro-en.vtt'
        },
        'case2': {
            title: 'Who knocked down the MH17?',
            titleBottom: 'Find evidence of attacks looking at the image',
            explanationInteraction: 'Selecciona los tuits para dibujar en el mapa el recorrido del camión',
            nameMenu: 'CASE 2',
            imageMenu: '/media/image/menu2.png',
            url: '/who-downed-mh17/',
            description: 'Investigate the proof on the attack on the MH17 to ascertain who is behind the attack.',
            button: 'Start research',
            buttonStart: 'Start',
            buttonSkip: 'Skip intro',
            buttonContinue: 'Continue',
            buttonGoInteractive: 'Interactive',
            background: 'media/image/bg-case2.jpg',
            logoFooter: 'media/image/logoEn.png',
            wordsParallax: ['media/image/word-about.png', 'media/image/word-forget.png', 'media/image/word-here.png', 'media/image/word-playing.png', 'media/image/word-to-win.png'],
            messages: [[{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'An aircraft has crashed in the Ukraine with nearly 300 people on board...',
                author: 'Lanchlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I’ve read about it... It said that some of the most prestigious HIV researchers were travelling on board. The images are terrible',
                author: 'Elcho',
                inbound: true,
                duration: 700,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/3244662.jpg',
                        subtitle: 'The remains of the aircraft were spread out in the east of Ukraine in an area of 50 square kilometres'
                    }, {
                        type: 'image',
                        src: 'media/image/7005205.jpg',
                        subtitle: 'However, most of the remains of the aircraft are located in Grabovo'
                    }, {
                        type: 'image',
                        src: 'media/image/7009893.jpg',
                        subtitle: 'Between July 14 and 17, a total of 61 airlines from 32 countries operated in Ukraine air space'
                    }, {
                        type: 'image',
                        src: 'media/image/7011359.jpg',
                        subtitle: 'The official investigation was the responsibility of seven countries (Holland, Ukraine, Malaysia, the United States, the United Kingdom, Australia and Russia)'
                    }, {
                        type: 'image',
                        src: 'media/image/7012588.jpg',
                        subtitle: 'Some media informed of the theft of credit cards from the victims'
                    }, {
                        type: 'image',
                        src: 'media/image/7270990.jpg',
                        subtitle: 'Inhabitants of the town of Torez were also injured as pieces of the aircraft damaged some houses'
                    }],
                    srcThumbnail: 'media/image/fotogaleriath.jpg',
                    hoverTitle: 'Image gallery',
                    hoverText: '298 people die on-board an aircraft while it was flying over the Ukraine.',
                    mediaId: 1
                },
                messageId: 1
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Oh my gosh! What has happened? Has it been a human or a technical error?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It’s not clear, but <a href="http://www.rtve.es/alacarta/videos/telediario/vuelo-mh17-fue-derribado-ucrania-impacto-externo-gran-numero-objetos/2747457/" target="_blank">they suspect it may have been an attack</a>',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Terrorists?',
                author: 'Lanchlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Not exactly. It fell when it was flying over an area in the Ukraine that is at war between the Ukrainian army and the pro-Russians',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }, {
                message: 'They say it could have been confused with a military plane',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'But what side was it?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: "Let's check it out",
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: 'Next case',
                    author: 'You',
                    skipMessageBlocks: 0,
                    link: '/who-destroyed-the-humanitarian-convoy/'
                }]
            }], [{
                message: 'The Kiev government is accusing the pro-Russians that control the area in which the plane fell, but they don’t have any proof',
                author: 'Lanchlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'And the paramilitaries and Russia - what do they say?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                message: 'That it was Kiev, in a move to blame them in the eyes of the public',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/tdMH17.mp4',
                        subtitle: 'Rusia acusa a Ucrania'
                    }],
                    srcThumbnail: 'media/image/ucraniatdth.jpg',
                    hoverTitle: 'Crossfire of accusations',
                    hoverText: 'None of the parties involved in the conflict acknowledge the attack, presenting different proof of what happened.',
                    mediaId: 2
                },
                messageId: 2
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'How can we verify it?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                message: 'We can begin by identifying the type of weapons capable of knocking down a plane. Do they know at what height the plane was flying?',
                author: 'Lanchlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The official records state that it was above 10,000 metres, the obligatory height in a war zone',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                message: 'Any idea of what type of missile reaches such height?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: "Let's check the type of missile",
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continue investigating',
                    author: 'You',
                    skipMessageBlocks: 5
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The media indicate that this type of missile was used. Look, this video explains why',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/buk.mp4',
                        srcSubtitles: 'media/subtitles/caso2-buk.vtt',
                        subtitle: 'Descripción de los misiles BUK',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/bukth.jpg',
                    hoverTitle: 'Verification of the type of weapon',
                    hoverText: 'Various sources state that the weapon used to shoot down the MH17 was a BUK missile launcher. Is that possible?',
                    mediaId: 3
                },
                messageId: 3
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'And who has this type of tank?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The Ukrainians have it, although a somewhat obsolete model. They are called BUKs <a href="https://es.wikipedia.org/wiki/Misil_Buk" target="_blank">BUK</a>',
                author: 'Lachlan',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'And does Russia have BUKs?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Russia has one of the largest arsenals in the world, and which is the most up-to-date... In fact, it is the Russians that are providing weapons to the supporters of the independence movement',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It seems that we are blocked here. How can we make progress?',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'One of the gurus of the verification, Eliot Higgins, founder of  <a href="https://www.bellingcat.com/" target="_blank">Bellingcat</a>, recommends this if you are beginning a verification',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/eliot1.mp4',
                        srcSubtitles: 'media/subtitles/caso2-higgins.vtt',
                        srcPoster: 'media/image/reid1.jpg',
                        subtitle: 'Eliot Higgins',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/eliot1th.jpg',
                    hoverTitle: 'Where to start an investigation?',
                    hoverText: 'Eliot Higgins, Bellingcat founder, tells you how to start looking for information about a case.',
                    mediaId: 4
                },
                messageId: 4
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I’m going to look in  <a href="https://twitter.com/search?q=%23MH17&src=tyah" target="_blank">Twitter</a> to see what it says',
                author: 'Lachlan',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Search on Twitter',
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: "Let's go ahead",
                    author: 'You',
                    skipMessageBlocks: 3
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'These are some of the tweets published 24 hours before the attack in the area',
                author: 'Elcho',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'twitter',
                        src: '781125242416721924',
                        subtitle: 'Esto es contenido del primer elemento'
                    }, {
                        type: 'twitter',
                        src: '489807649509478400',
                        subtitle: 'Segundo elemento'
                    }, {
                        type: 'twitter',
                        src: '781116583825506306',
                        subtitle: 'Tercer elemento'
                    }, {
                        type: 'twitter',
                        src: '490646489484374017',
                        subtitle: 'Tercer elemento'
                    }, {
                        type: 'twitter',
                        src: '490645773638307840',
                        subtitle: 'Tercer elemento'
                    }],
                    srcThumbnail: 'media/image/tuitth.jpg',
                    hoverTitle: 'A trail in the sky',
                    hoverText: 'Different images (published on Twitter, Facebook, VK...) in the Pervomaysk rebel area reveal the trail of a missile in the area when the plane was knocked down.',
                    mediaId: 5
                },
                messageId: 5
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'In some of them, the trail of a missile can be seen in the sky...',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Yes, and in many others a truck appears carrying a tank that seems to be a BUK',
                author: 'Lachlan',
                inbound: true,
                duration: 1000
            }], [{
                message: 'According to the investigators of the Dutch-led Joint Investigation Team (<a href="https://www.politie.nl/themas/flight-mh17-2.html" target="_blank">JIT</a>) the smoke trail was seen in the Pervomaysk area, in north-east Ukraine',
                author: 'Lachlan',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d206298.71937171486!2d38.414511344577505!3d48.60790908938558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40e003b178e14c25%3A0xed72d30bea2efce0!2sPervomaisk%2C+Lugansk%2C+Ucrania!5e1!3m2!1ses!2ses!4v1479989575805',
                        subtitle: 'Estimated location of missile launch'
                    }],
                    srcThumbnail: 'media/image/pervomayskth.jpg',
                    hoverTitle: "BUK's location",
                    hoverText: 'The tracks on the location of the earth-air battery that has knocked down the MH17 locate it near the town of Pervomaysk.',
                    mediaId: 6
                },
                messageId: 6
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Is it possible to observe whether that BUK seen in the photos was in the area?',
                author: 'Fraser',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'We can see its course based on where such tweets were published',
                author: 'Elcho',
                inbound: true,
                duration: 1000
            }]],
            parallaxContent: [{
                type: 'image',
                velocity: '0.65',
                img: 'lineCase2.png'
            }, {
                type: 'string',
                velocity: '0.5',
                txt: 'Case'
            }, {
                type: 'string',
                velocity: '0.20',
                txt: 'MH 17'
            }, {
                type: 'image',
                velocity: '0.30',
                img: 'lineCase2.png'
            }, {
                type: 'string',
                velocity: '0.4',
                txt: '<h1>Who knocked down the MH17?</h1>'
            }, {
                type: 'image',
                velocity: '0.3',
                img: 'rectangleCase2.png'
            }],
            interaction: {
                instructions: {
                    title: 'Look for the tweets which are related to the transfer of the BUK in order to check its location',
                    topText: 'Select the tweets which contain crucial information related to the BUK',
                    bottomText: 'The map shows the place in which the BUK was seen and indicates its route',
                    originText: 'On land near Pervomaysk, to the north west of Donetsk, is the one indicated by the JIT as the place where the missile was launched',
                    destinationText: 'Flight MH17 feel at this point, near the town of Grabovo'
                },
                tweetsSrc: ['/media/image/1 EN.png', '/media/image/2 EN.png', '/media/image/3 EN.png', '/media/image/4 EN.png', '/media/image/5 EN.png', '/media/image/6 EN.png', '/media/image/7 EN.png', '/media/image/8 EN.png', '/media/image/9 EN.png', '/media/image/10 EN.png'],
                wrongText: 'Keep on searching<br>This twit was not publish in the geographical area and it is not related with the BUK´s transport'
            },
            conclusion: {
                title: 'Conclusions',
                text: ['This verification certifies that the MH17 passenger plane was knocked down by a ground-to-air missile.', 'The assumption of a breakdown or explosion as a result of a terrorist attach has been ruled out. The possibility of an air attack has also been ruled out.', 'We can also state that a BUK tank of the Russian army travelled on the day of the attack from the rebel city of Donesck to the area from which the missile was launched.', 'This evidence indicates that the death of 298 civilians was due to an attack by the rebels allied with Russia although it cannot be proven whether it was intentional or not.', 'This verification is inspired on the conclusions of the JIT, and on the preliminary work of Bellingcat.'],
                verification: {
                    text: 'JIT',
                    link: 'https://www.om.nl/onderwerpen/mh17-vliegramp/presentaties/presentation-joint/'
                },
                nextStep: {
                    text: 'Next case',
                    link: '/who-destroyed-the-humanitarian-convoy/'
                },
                icon: 'icon-plane'
            },
            icon: 'icon-plane',
            urlVideo: '/media/video/introCase2.mp4',
            urlSubtitles: '/media/subtitles/caso2-intro-en.vtt'
        },
        'case3': {
            title: 'Who attacked the convoy at Urm Al Kubra?',
            titleBottom: 'Instrucciones del interactivo',
            explanationInteraction: '',
            nameMenu: 'CASE 3',
            imageMenu: '/media/image/menu3.png',
            url: '/who-destroyed-the-humanitarian-convoy/',
            description: 'Ascertain whether the convoy attack was premeditated and what type of attack destroyed the humanitarian aid.',
            button: 'Start Research',
            buttonStart: 'Start',
            buttonSkip: 'Skip intro',
            buttonContinue: 'Continue',
            buttonGoInteractive: 'Interactive',
            background: 'media/image/bg-case2.jpg',
            logoFooter: 'media/image/logoEn.png',
            wordsParallax: ['media/image/word-about.png', 'media/image/word-forget.png', 'media/image/word-here.png', 'media/image/word-playing.png', 'media/image/word-to-win.png'],
            messages: [[{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The UN has suspended the dispatch of humanitarian aid to Syria',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'What? That’s impossible! Thousands of people depend on such aid to survive',
                author: 'Luzader',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'What has happened?',
                author: 'Nickerson',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It appears that a Red Cross convoy prepared to distribute food, medicines and blankets was bombarded',
                author: 'Grant',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/tdConvoy.mp4',
                        subtitle: 'The UN has suspended the dispatch of humanitarian aid to Syria. TVE News. September 20, 2016.'
                    }],
                    srcThumbnail: 'media/image/onuconvoyth.jpg',
                    hoverTitle: 'N suspends aid deliveries',
                    hoverText: 'The attack on the convoy of UNHCR and Red Cross provokes the cancellation of humanitarian operations in Syria.',
                    mediaId: 1
                },
                messageId: 1
            }], [{
                message: 'They say that operations have been suspended due to the lack of security in the area',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Who do you think it was? Normally the position of humanitarian aid must be public so that such things do not happen',
                author: 'Nickerson',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It would be necessary to confirm whether its position was known by the armies fighting for control of Alepo...',
                author: 'Luzader',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: "Let's see statements",
                    author: 'Tú',
                    skipMessageBlocks: 0
                }, {
                    message: 'Make progress in the investigation',
                    author: 'Tú',
                    skipMessageBlocks: 5
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The UN confirms that its position was known',
                author: 'Luzader',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'twitter',
                        src: '778036930567176196',
                        subtitle: "Stephen O'Brien announcement"
                    }],
                    srcThumbnail: 'media/image/unchiefth.jpg',
                    hoverTitle: 'UN Statements',
                    hoverText: "UN Humanitarian Representative Stephen O'Brien says on Twitter that the position of the convoy was public.",
                    mediaId: 2
                },
                messageId: 2
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'And what does Russia say?',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'According to the Russian TV channel RT, the Defence Ministry spokesman, Igor Konashenkov, stated that “<a href="https://www.rt.com/news/359990-russia-denies-aleppo-strike/" target="_blank">the convoy has successfully carried out its objective</a>””, whereby it was deduced that the Russian army was aware of its location...',
                author: 'Nickerson',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.rt.com/news/359990-russia-denies-aleppo-strike/video/',
                        subtitle: 'RT News'
                    }],
                    srcThumbnail: 'media/image/russiadeniesth.jpg',
                    hoverTitle: 'Russia denies bombing convoy',
                    hoverText: 'Igor Konashenkov, denies any intervention in the attack.',
                    mediaId: 3
                },
                messageId: 3
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Everybody knew where the convoy was but nobody is taking responsibility for the attack...',
                author: 'Nickerson',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Gosh if they knew... There are even images on Youtube of the Russian monitoring of the convoy using a drone',
                author: 'Luzader',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/egwLxk-ypKk?autoplay=1&enablejsapi=1',
                        subtitle: 'Imágenes de dron'
                    }],
                    srcThumbnail: 'media/image/dronth.jpg',
                    hoverTitle: 'A Russian dron controls the convoy',
                    hoverText: 'Russia has images of the humanitarian convoy recorded by a dron, which can be seen on Youtube.',
                    mediaId: 4
                },
                messageId: 4
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'One thing at a time: The UN points the finger at Al Assad and Russia',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'On their part, the Russians state that it was Al Nusra, the subsidiary of Al Qaeda in the area',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Could it have been Jihadists?',
                author: 'Luzader',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I don’t think so… They normally acknowledge attacks of this type when they’ve been committed',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }, {
                message: 'And they haven’t done so to date',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'You feel so powerless. How can we find out who did it?',
                author: 'Nickerson',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'We can begin by verifying the information available on internet on the matter. First identify and then verify',
                author: 'Luzader',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'That is what Eliot Higgins, founder of <a href="https://www.bellingcat.com/" target="_blank">Bellingcat</a>, always says on his work',
                author: 'Grant',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/higgins1.mp4',
                        srcSubtitles: 'media/subtitles/caso3-higgins.vtt',
                        subtitle: 'Eliot Higgins',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/higgins1th.jpg',
                    hoverTitle: 'Tools of verification',
                    hoverText: 'Eliot Higgins, founder of Bellingcat, gives us the key keys to carry out verification processes.',
                    mediaId: 5
                },
                messageId: 5
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Let us begin with the type of weapon used. Al Nusra does not have bomber planes for example…',
                author: 'Luzader',
                inbound: true,
                duration: 1000
            }, {
                type: 'choice',
                duration: 1000,
                inbound: true,
                choices: [{
                    message: 'Check the weapons',
                    author: 'You',
                    skipMessageBlocks: 0
                }, {
                    message: 'Continue',
                    author: 'You',
                    skipMessageBlocks: 2
                }]
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'I think that there’s a video of the attack on <a href="https://www.youtube.com/results?search_query=WFP+trucks+attack+syria" target="_blank">Youtube</a>',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Yes, I’ve found one. This witness tells how various helicopters and planes flew over the area before and during the attack',
                author: 'Luzader',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'iframe',
                        src: 'https://www.youtube.com/embed/K4G5kNeTClQ?autoplay=1&enablejsapi=1',
                        subtitle: "White Helmet's testimony"
                    }],
                    srcThumbnail: 'media/image/cascoth.jpg',
                    hoverTitle: 'Images of the attack',
                    hoverText: 'A White Helmet of the Syrian Civil Defense explains on the ground the damages caused and what type of attack has been',
                    mediaId: 6
                },
                messageId: 6
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'The information published by <a href="https://www.rt.com/news/359990-russia-denies-aleppo-strike/" target="_blank">RT</a> states that the spokesman of the Russian army declared, and I quote:',
                author: 'Nickerson',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'image',
                        src: 'media/image/translation.jpg',
                        subtitle: 'Declaraciones de Igor Konashenkov, portavoz del Ejército ruso.'
                    }],
                    srcThumbnail: 'media/image/traduccionth.jpg',
                    hoverTitle: 'Russia denies air raid',
                    hoverText: 'The Russian Army says that the images on the ground certify that the attack was terrestrial.',
                    mediaId: 7
                },
                messageId: 7
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It is possible to verify it by checking the videos of the attack',
                author: 'Grant',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'We can find the stills which show the damage to vehicles and buildings and from there clarify the type of weapon used',
                author: 'Nickerson',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Ok, here is some advice on how to find relevant information',
                author: 'Luzader',
                inbound: true,
                duration: 1000
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'It’s from Alastair Reid, director of <a href="https://firstdraftnews.com/" target="_blank">First Draft</a>',
                author: 'Luzader',
                inbound: true,
                duration: 1000,
                showMedia: {
                    elements: [{
                        type: 'video',
                        src: 'media/video/alastair1.mp4',
                        srcSubtitles: 'media/subtitles/caso3-reid.vtt',
                        subtitle: 'Alastair Reid',
                        subtitleOn: true
                    }],
                    srcThumbnail: 'media/image/alastair1th.jpg',
                    hoverTitle: 'How to verify images',
                    hoverText: 'Alastair Reid of First Draft News explains the basics of checking if a picture is false.',
                    mediaId: 8
                },
                messageId: 8
            }], [{
                type: 'typing',
                duration: 1000,
                inbound: true
            }, {
                message: 'Ok, let us see what we can find',
                author: 'Nickerson',
                inbound: true,
                duration: 1000
            }]],
            parallaxContent: [{
                type: 'image',
                velocity: '0.65',
                img: 'lineCase3.png'
            }, {
                type: 'string',
                velocity: '0.5',
                txt: 'Case'
            }, {
                type: 'string',
                velocity: '0.20',
                txt: 'Convoy'
            }, {
                type: 'image',
                velocity: '0.30',
                img: 'lineCase3.png'
            }, {
                type: 'string',
                velocity: '0.4',
                txt: '<h1>Who attacked the convoy at Urm Al Kubra?</h1>'
            }, {
                type: 'image',
                velocity: '0.3',
                img: 'rectangleCase3.png'
            }],
            interaction: {
                instructions: "Look at the convoy's images for evidence of an attack",
                photo1: {
                    title: 'Aerial bombs normally cause serious damage to vehicles',
                    subtitle: 'Look for signs that the truck has been hit by a bomb',
                    resolution: 'The image shows clearly how the truck cab has been destroyed.',
                    copyright: 'Image: AMP'
                },
                photo2: {
                    title: 'The air attacks launch missiles which spread shrapnel on exploding and this causes serious damage',
                    subtitle: 'Look at the vehicle for at least three missile shrapnel impact samples',
                    resolution: 'The holes in the bodywork are not normally the result of a fire, but of an attack.',
                    copyright: 'Image: وكالة ثقة.'
                },
                photo3: {
                    title: 'The missiles launched from the air can cause the irreparable collapse of infrastructures',
                    subtitle: 'Indicates the points in the building where most damage was caused',
                    resolution: 'The way in which the building has collapsed show that it suffered an air attack.',
                    copyright: 'Image: وكالة ثقة.'
                },
                wrongText: 'Keep on searching <br>This is not a clue of the attack'
            },
            conclusion: {
                title: 'Conclusions',
                text: ['With these investigations, we can conclude that the damage caused in the area demonstrates that the convoy was hit by an air attack, as reflected in the exhaustive report published by Bellingcat.', 'Both the UN and the Russian Ministry of Defence confirmed that they were aware of the convoy site before the attack.', 'Witness testimonies reinforce the theory that an air attack with barrel bombs took place on 19 September 2016 against humanitarian aid earmarked for the population of Alepo, Syria.'],
                verification: {
                    text: 'Bellingcat',
                    link: 'https://www.bellingcat.com/news/mena/2016/09/21/aleppo-un-aid-analysis/'
                },
                nextStep: {
                    text: 'You can do it',
                    link: '/who-verified-internationtal-wars/'
                }
            },
            urlVideo: '/media/video/introCase3.mp4',
            urlSubtitles: '/media/subtitles/caso3-intro-en.vtt'
        },
        common: {
            scroll: 'Scroll',
            conclusion: {
                subMenu: {
                    text1: 'VIDEO',
                    text2: 'WATCH VIDEO',
                    imgSrc: '/media/image/menuVideoFinalCase.jpg'
                }
            }
        }
    },
    FinalVideo: {
        srcVideo: '/media/video/finalCase.mp4',
        srcSubtitles: '/media/subtitles/final-case-en.vtt',
        urlNext: 'tutorials/',
        buttonContinue: 'Continue'
    },
    Documentary: {
        srcVideo: 'https://video-lab.rtve.es/resources/TE_NGVA/mp4/2017/guerra-mentira/documentalEN.mp4',
        urlSubtitles: '/media/subtitles/documentalEN.vtt'
    },
    ComingUp: {
        instructions: [{
            txt: 'Documentary premiere coming up next Monday 30th of January at 11.30pm',
            icon: ''
        }, {
            txt: 'You can watch it <a href="http://www.rtve.es/directo/la-2/" target="_blank">on La 2 channel and RTVE.es</a>',
            icon: ''
        }],
        buttonContinue: 'Continue'
    }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/i18n/en.js
// module id = 822
// module chunks = 0